import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

import VueResource from 'vue-resource'
Vue.use(VueResource)

var a = encodeURIComponent(Vue.cookie.get('fb2c8bb1eb02d7cfce7574c0d2e30b22')
)
var b = encodeURIComponent(Vue.cookie.get('5e3cf055942b4a4fe97620337b5cbf3e')
)

Vue.http.headers.common[
	'X-fb2c8bb1eb02d7cfce7574c0d2e30b22'
] = a
Vue.http.headers.common[
	'X-5e3cf055942b4a4fe97620337b5cbf3e'
] = b

Vue.config.productionTip = false

import components from './components'
Vue.use(components)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
